import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();
export const getSurveysForms = (params: any) => {
    return axios({
      method: "GET",
      url: "/survey-form",
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

export const createSurveysForms = (data: unknown, id: any) => {
  return axios({
    method: id ? "PUT":"POST",
    url: id ? `/survey-form/${id}`: "/survey-form",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const shareSurveysForms = (data: unknown, id: any) => {
  return axios({
    method: "POST",
    url: `/survey-form/${id}/share`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const deleteForm = (formId: number ) => {
  return axios({
    method: "DELETE",
    url: `/survey-form/${formId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getSurveySubmittedForms = (params: any, moduleName?: string, id?: any) => {
  return axios({
    method: "GET",
    url: `/survey-form/${id}/serveyData`,
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};

export const getSurveySubmittedFormsByID = (id: any) => {
  return axios({
    method: "GET",
    url: `/survey-form/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getQRCode = (params: any) => {
    return axios({
      method: "GET",
      url: "/survey-form/qr-codes",
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };